<div class="content-summary">
    <div class="summary-views">
        <router-outlet></router-outlet>
    </div>
    <div class="footer-information">
        <div class="height-menu"></div>
    </div>
</div>